import { Box, Container, Grid, Typography } from "@mui/material";
import React from "react";
import { images } from "../../assets";
import { allColors } from "../../constants";

const dummyData = [
  {
    id: 1,
    name: "Yealink W53P",
    image: images.yeaLinkPhonImg2,
  },
  {
    id: 2,
    name: "Yealink W73P",
    image: images.yeaLinkPhonImg3,
  },
  {
    id: 3,
    name: "Yealink T40G",
    image: images.yeaLinkPhonImg4,
  },
  {
    id: 4,
    name: "Yealink W56P",
    image: images.yealinkPhoneSilverShadowImg,
  },
];

const HandsetsSection = () => {
  return (
    <Box
      id="handsets"
      sx={{
        background: allColors.brightGray,
        padding: "50px 0 60px",
      }}
    >
      <Container
        sx={{
          maxWidth: "1250px !important",
          textAlign: "center",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Raleway",
            textAlign: "center",
            fontSize: { xs: "20px", sm: "30px", md: "50px" },
            color: allColors.jetBlack,
            fontWeight: "700",
          }}
        >
          The right phone for your business
        </Typography>
        <Typography
          sx={{
            textAlign: "center",
            fontSize: { xs: "14px", sm: "16px", md: "20px" },
            color: allColors.jetBlack,
            fontWeight: "300",
            marginTop: "12px",
            marginBottom: "25px",
            fontFamily: "Raleway",
          }}
        >
          Explore our selection of handsets
        </Typography>
        <Grid container alignItems={"flex-end"} justifyContent={"center"}>
          {dummyData.map((itemmmm, inddd) => {
            return (
              <Grid
                item
                xs={6}
                md={3}
                key={itemmmm.id}
                marginTop={{ xs: "15px", sm: 0 }}
              >
                <img
                  src={itemmmm.image}
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                  alt={itemmmm.image}
                />
                <Typography
                  sx={{
                    fontSize: { xs: "12px", sm: "16px" },
                    // fontSize: { xs: "16px", sm: "20px" },
                    fontWeight: "400",
                    color: allColors.jetBlack,
                    fontFamily: "Raleway",
                  }}
                >
                  {itemmmm.name}
                </Typography>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </Box>
  );
};

export default HandsetsSection;
